/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createCombinations } from '../../factoriesAny.js';
export var combinationsDependencies = {
  typedDependencies: typedDependencies,
  createCombinations: createCombinations
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesCombinations.generated.js
// module id = 226
// module chunks = 0